// VendorQuotationExcelImportEditScreen.jsx
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useAppMeta } from "hooks";
import {
    useGetVendorQuotationExcelDetailQuery,
    useUpdateVendorQuotationExcelMutation,
} from "store/services/vendorQuotationExcelApi";
import VendorQuotationExcelImportForm from "./vendorQuotationExcelComponents/VendorQuotationExcelImportForm";

const VendorQuotationExcelImportEditScreen = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const breadcrumbs = [
        { title: "Vendor Quotation Excels", path: "/app/crm/vendor-quotation-excel/list" },
        { title: "Edit Vendor Quotation Excel Import" },
    ];

    const {
        data: priceListDetail,
        isLoading: loadingDetail,
        error,
    } = useGetVendorQuotationExcelDetailQuery(id);

    const [updateVendorQuotationExcel, { isLoading: updating }] =
        useUpdateVendorQuotationExcelMutation();

    const handleUpdate = async (data) => {
        try {
            await updateVendorQuotationExcel({ _id: id, ...data }).unwrap();
            toast.success("Vendor Quotation Excel successfully updated!");
            navigate(`/app/crm/vendor-quotation-excel/${id}/detail`);
        } catch (err) {
            toast.error(
                err?.data?.message ?? err?.message ?? "Couldn't update Vendor Quotation Excel!",
            );
        }
    };

    useAppMeta("Edit Vendor Quotation Excel");

    return (
        <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={loadingDetail || updating}>
            <BreadcrumbLayout.Error error={error} />
            <BreadcrumbLayout.Paper>
                <VendorQuotationExcelImportForm
                    isBusy={loadingDetail || updating}
                    priceListDetail={priceListDetail}
                    onSubmit={handleUpdate}
                />
            </BreadcrumbLayout.Paper>
        </BreadcrumbLayout>
    );
};

export default VendorQuotationExcelImportEditScreen;